'use strict';

var _ = require('lodash');
function FaresSurchargeUploadImportService(restangular) {
  var fileUploadApi = restangular.service('domain').one('surcharge').one('csv');
  function importMarketClassSurcharges(file) {
    var formData = new FormData();
    formData.append('file', file);
    return fileUploadApi.customPOST(formData, '', undefined, {
      'Content-Type': undefined
    });
  }
  function setUpImportErrorLogData(allRows) {
    return _.transform(allRows, function (result, entry, index) {
      var newEntry = _.clone(entry);
      newEntry.rowId = index + 1;
      return result.push(newEntry);
    });
  }
  function findInvalidRows(validatedRows) {
    return _.filter(validatedRows, function (row) {
      return !row.valid;
    });
  }
  return {
    importMarketClassSurcharges: importMarketClassSurcharges,
    setUpImportErrorLogData: setUpImportErrorLogData,
    findInvalidRows: findInvalidRows
  };
}
FaresSurchargeUploadImportService.$inject = ['Restangular'];
module.exports = FaresSurchargeUploadImportService;